import React from 'react';
import { Download } from 'lucide-react';
import Marquee from 'react-fast-marquee';
import Footer from '../components/Footer';
import SEOHead from '../seo/SEOHead';
import { PAGE_SEO } from '../seo/seoConfig';

import logo4 from '../assets/BIS.png';
import logo2 from '../assets/logo2.png';
import logo3 from '../assets/logo3.png';
import logo1 from '../assets/logo4.png';
import bisPdf from '../assets/BIS-License.pdf';
import iso from '../assets/ISO.PDF';
import kenya from '../assets/kenya.pdf';
import TBS from '../assets/TBS.pdf';
import TBS1 from '../assets/TBS1.pdf';
import safety from '../assets/safety.jpeg';
import safety2 from '../assets/durability.jpeg';
import safety3 from '../assets/testing.jpeg';
import durability from '../assets/testing1.jpeg';
import durability2 from '../assets/testing2.jpeg';

const CertificationsPage = () => {

  const handleDownload = (certificateName, pdfPath) => {
    if (pdfPath) {
      const link = document.createElement('a');
      link.href = pdfPath;
      link.download = `${certificateName}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      alert(`${certificateName} certificate is not available yet.`);
    }
  };

  const certifications = [
    {
      id: 1,
      name: 'Tanzania Bureau of Standards',
      shortName: 'TBS',
      logo: logo1,
      downloadName: 'Tanzania Bureau of Standards Certificate',
      pdfPath: TBS1
    },
    {
      id: 2,
      name: 'Bureau of Indian Standards',
      shortName: 'BIS',
      logo: logo2,
      downloadName: 'Bureau of Indian Standards Certificate',
      pdfPath: bisPdf
    },
    {
      id: 3,
      name: 'Tanzania Bureau of standards',
      shortName: 'TBS',
      logo: logo3,
      downloadName: 'Tanzania Bureau of standards Certificate',
      pdfPath: TBS
    },
    {
      id: 4,
      name: 'Kenya Bureau of Standards',
      shortName: 'KEBS',
      logo: logo4,
      downloadName: 'Kenya Bureau of Standards Certificate',
      pdfPath: kenya
    },
    {
      id: 5,
      name: 'ISO 9001:2015',
      shortName: 'ISO',
      logo: null,
      downloadName: 'ISO 9001:2015 Certificate',
      pdfPath: iso
    },
    {
      id: 6,
      name: 'Extended BIS Certification',
      shortName: 'BIS',
      logo: logo2,
      downloadName: 'EXTENDED BIS CERTIFICATE',
      pdfPath: bisPdf
    }
  ];

  return (
    <>
      <SEOHead
        title={PAGE_SEO.certifications.title}
        description={PAGE_SEO.certifications.description}
        keywords={PAGE_SEO.certifications.keywords}
        canonical={PAGE_SEO.certifications.canonical}
        ogImage={PAGE_SEO.certifications.ogImage}
      />
      <div className="cert-page-wrapper">
        {/* Header Section */}
        <section className="cert-header-section">
          <div className="cert-main-container">
            <h1 className="cert-page-title">Quality You Can Trust</h1>
            <p className="cert-page-subtitle">
              Our commitment to excellence is validated by leading certification bodies worldwide
            </p>
          </div>
        </section>

        {/* Certifications Marquee Section */}
        <section className="cert-marquee-section">
          <div className="cert-main-container">
            <h2 className="cert-section-heading">
              Our <span className="text-highlight">Certifications</span>
            </h2>
          </div>

          <div className="cert-marquee-wrapper">
            <Marquee
              gradient={true}
              gradientColor={[255, 255, 255]}
              gradientWidth={40}
              speed={40}
              pauseOnHover={true}
              className="cert-marquee"
            >
              {certifications.filter(cert => cert.logo).map((cert) => (
                <div key={`marquee-1-${cert.id}`} className="cert-logo-card">
                  <img
                    src={cert.logo}
                    alt={cert.name}
                    className="cert-logo-img"
                  />
                </div>
              ))}
              {certifications.filter(cert => cert.logo).map((cert) => (
                <div key={`marquee-2-${cert.id}`} className="cert-logo-card">
                  <img
                    src={cert.logo}
                    alt={cert.name}
                    className="cert-logo-img"
                  />
                </div>
              ))}
            </Marquee>
          </div>
        </section>

        {/* Download Section */}
        <section className="cert-download-section">
          <div className="cert-main-container">
            <h3 className="cert-sub-heading">Download Our Certificates</h3>
            <div className="cert-download-grid">
              {certifications.map((cert) => (
                <button
                  key={cert.id}
                  className="cert-download-btn"
                  onClick={() => handleDownload(cert.downloadName, cert.pdfPath)}
                >
                  <Download size={18} className="download-btn-icon" />
                  <span>{cert.downloadName}</span>
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Reliability Section */}
        <section className="cert-reliability-section">
          <div className="cert-main-container">
            <h2 className="cert-section-heading left-align">Reliability Through Testing</h2>
            
            <div className="cert-reliability-box">
              {/* Top Feature Row */}
              <div className="cert-feature-card">
                <div className="cert-feature-img-wrapper">
                  <img
                    src={durability}
                    alt="RealFlame PNG stove durability testing"
                    className="cert-feature-img"
                    loading="lazy"
                  />
                </div>
                <div className="cert-feature-content">
                  <h3 className="cert-feature-title">Engineered for Safety</h3>
                  <p className="cert-feature-desc">
                    Each RealFlame product undergoes rigorous quality checks to ensure reliable ignition, stable performance, and maximum safety in every environment. Our testing standards meet and exceed industry benchmarks for gas appliance safety.
                  </p>
                </div>
              </div>

              {/* Bottom Feature Row */}
              <div className="cert-feature-card reverse-row">
                <div className="cert-feature-img-wrapper">
                  <img
                    src={durability2}
                    alt="RealFlame gas stove quality control testing lab"
                    className="cert-feature-img"
                    loading="lazy"
                  />
                </div>
                <div className="cert-feature-content">
                  <h3 className="cert-feature-title">Tested For Durability</h3>
                  <p className="cert-feature-desc">
                    From high-temperature resistance to extensive long-hour operational testing, our stoves are engineered to perform with unwavering reliability in the most challenging environments. Each unit undergoes rigorous quality assessments to ensure it can withstand continuous use, heavy workloads, and fluctuating conditions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Safety Section */}
        <section className="cert-safety-section">
          <div className="cert-main-container">
            <h2 className="cert-section-heading left-align">Designed With Safety In Mind</h2>

            <div className="cert-safety-grid">
              <div className="cert-safety-card">
                <div className="cert-safety-img-wrapper">
                  <img
                    src={safety}
                    alt="RealFlame high pressure gas safety testing"
                    className="cert-safety-img"
                    loading="lazy"
                  />
                </div>
                <div className="cert-safety-body">
                  <p className="cert-safety-desc">
                    Built for safety, tested for lasting performance.
                  </p>
                </div>
              </div>

              <div className="cert-safety-card">
                <div className="cert-safety-img-wrapper">
                  <img
                    src={safety3}
                    alt="RealFlame PNG stove flame stability mechanism"
                    className="cert-safety-img"
                    loading="lazy"
                  />
                </div>
                <div className="cert-safety-body">
                  <p className="cert-safety-desc">
                    Reliable flames. Secure cooking. Everyday peace of mind.
                  </p>
                </div>
              </div>

              <div className="cert-safety-card">
                <div className="cert-safety-img-wrapper">
                  <img
                    src={safety2}
                    alt="RealFlame brass burner safety construction"
                    className="cert-safety-img"
                    loading="lazy"
                  />
                </div>
                <div className="cert-safety-body">
                  <p className="cert-safety-desc">
                    Every flame controlled. Every meal, worry-free.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <style jsx>{`
          .cert-page-wrapper {
            width: 100%;
            background-color: #ffffff;
            color: #000000;
            font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            padding-bottom: 60px;
            overflow-x: hidden;
          }

          .cert-main-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
            box-sizing: border-box;
          }

          /* Header Section */
          .cert-header-section {
            padding: 40px 0 24px 0;
            text-align: center;
          }

          .cert-page-title {
            font-size: 2.25rem;
            font-weight: 600;
            color: #111827;
            margin: 0 0 12px 0;
            line-height: 1.3;
          }

          .cert-page-subtitle {
            font-size: 1.05rem;
            color: #4b5563;
            max-width: 680px;
            margin: 0 auto;
            line-height: 1.6;
          }

          /* Marquee Section */
          .cert-marquee-section {
            padding: 24px 0 40px 0;
          }

          .cert-section-heading {
            font-size: 1.85rem;
            font-weight: 600;
            color: #111827;
            margin-bottom: 24px;
            text-align: center;
          }

          .cert-section-heading.left-align {
            text-align: left;
          }

          .text-highlight {
            color: #F58220;
          }

          .cert-marquee-wrapper {
            width: 100%;
            padding: 16px 0;
            background: #FAFAFA;
            border-top: 1px solid #F3F4F6;
            border-bottom: 1px solid #F3F4F6;
          }

          .cert-logo-card {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 12px 36px;
          }

          .cert-logo-img {
            max-height: 80px;
            width: auto;
            max-width: 160px;
            object-fit: contain;
            transition: transform 0.3s ease;
          }

          .cert-logo-card:hover .cert-logo-img {
            transform: scale(1.06);
          }

          /* Download Section */
          .cert-download-section {
            padding: 36px 0;
          }

          .cert-sub-heading {
            font-size: 1.35rem;
            font-weight: 600;
            color: #111827;
            margin-bottom: 20px;
            text-align: left;
          }

          .cert-download-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
            gap: 16px;
          }

          .cert-download-btn {
            background: linear-gradient(135deg, #F58220, #E6741D);
            color: #ffffff;
            border: none;
            padding: 14px 20px;
            font-size: 0.95rem;
            font-weight: 500;
            border-radius: 8px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            transition: transform 0.25s ease, box-shadow 0.25s ease;
            box-shadow: 0 4px 12px rgba(245, 130, 32, 0.2);
            text-align: center;
          }

          .cert-download-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 18px rgba(245, 130, 32, 0.35);
          }

          .download-btn-icon {
            flex-shrink: 0;
          }

          /* Reliability Section */
          .cert-reliability-section {
            padding: 40px 0;
          }

          .cert-reliability-box {
            display: flex;
            flex-direction: column;
            gap: 32px;
            background-color: #FFF8F2;
            border-radius: 16px;
            padding: 36px;
            border: 1px solid #FFE4D0;
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.03);
          }

          .cert-feature-card {
            display: flex;
            align-items: center;
            gap: 32px;
            background: #ffffff;
            border-radius: 12px;
            padding: 24px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
            border: 1px solid #F3F4F6;
          }

          .cert-feature-card.reverse-row {
            flex-direction: row-reverse;
          }

          .cert-feature-img-wrapper {
            flex: 0 0 320px;
            height: 220px;
            border-radius: 8px;
            overflow: hidden;
            background-color: #E5E7EB;
          }

          .cert-feature-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.4s ease;
          }

          .cert-feature-card:hover .cert-feature-img {
            transform: scale(1.03);
          }

          .cert-feature-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }

          .cert-feature-title {
            font-size: 1.4rem;
            font-weight: 600;
            color: #111827;
            margin: 0 0 12px 0;
          }

          .cert-feature-desc {
            font-size: 0.98rem;
            color: #4b5563;
            line-height: 1.65;
            margin: 0;
          }

          /* Safety Section */
          .cert-safety-section {
            padding: 40px 0 20px 0;
          }

          .cert-safety-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 24px;
          }

          .cert-safety-card {
            background: #ffffff;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
            border: 1px solid #F3F4F6;
            display: flex;
            flex-direction: column;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .cert-safety-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
          }

          .cert-safety-img-wrapper {
            width: 100%;
            height: 220px;
            overflow: hidden;
            background-color: #F3F4F6;
          }

          .cert-safety-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.4s ease;
          }

          .cert-safety-card:hover .cert-safety-img {
            transform: scale(1.05);
          }

          .cert-safety-body {
            padding: 18px 20px;
            border-bottom: 4px solid #F58220;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #ffffff;
          }

          .cert-safety-desc {
            font-size: 0.95rem;
            color: #374151;
            line-height: 1.5;
            font-weight: 500;
            text-align: center;
            margin: 0;
          }

          /* Responsive Breakpoints */
          @media (max-width: 1024px) {
            .cert-feature-img-wrapper {
              flex: 0 0 260px;
              height: 190px;
            }

            .cert-safety-grid {
              grid-template-columns: repeat(3, 1fr);
              gap: 16px;
            }
          }

          @media (max-width: 768px) {
            .cert-page-title {
              font-size: 1.75rem;
            }

            .cert-section-heading {
              font-size: 1.5rem;
              text-align: center;
            }

            .cert-section-heading.left-align {
              text-align: center;
            }

            .cert-sub-heading {
              text-align: center;
            }

            .cert-reliability-box {
              padding: 20px;
              gap: 20px;
            }

            .cert-feature-card,
            .cert-feature-card.reverse-row {
              flex-direction: column;
              text-align: center;
              padding: 20px;
              gap: 16px;
            }

            .cert-feature-img-wrapper {
              width: 100%;
              flex: none;
              height: 200px;
            }

            .cert-safety-grid {
              grid-template-columns: 1fr;
              gap: 20px;
            }

            .cert-safety-img-wrapper {
              height: 200px;
            }

            .cert-download-grid {
              grid-template-columns: 1fr;
            }
          }

          @media (max-width: 480px) {
            .cert-main-container {
              padding: 0 16px;
            }

            .cert-page-title {
              font-size: 1.5rem;
            }

            .cert-page-subtitle {
              font-size: 0.95rem;
            }

            .cert-feature-img-wrapper {
              height: 170px;
            }

            .cert-safety-img-wrapper {
              height: 180px;
            }
          }
        `}</style>
      </div>
      <Footer />
    </>
  );
};

export default CertificationsPage;